var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.081,
    height: 25,
    viewBox: "0 0 22.081 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#434343;}.a{stroke:#fff;stroke-miterlimit:10;stroke-width:0.15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.25 1.569)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M809.1,304.6",
    transform: "translate(-809.096 -304.603)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M798.5,310.458a10.988,10.988,0,0,0-2.967,7.235h.945a10.011,10.011,0,0,1,2.695-6.561Z",
    transform: "translate(-795.537 -304.031)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M799.2,326.522a10.078,10.078,0,0,1-2.718-6.53h-.946a11.023,11.023,0,0,0,3,7.2Z",
    transform: "translate(-795.537 -305.655)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M806.922,307.184v-.944a11,11,0,0,0-7.235,3.015l.673.673A10.067,10.067,0,0,1,806.922,307.184Z",
    transform: "translate(-796.244 -303.313)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M806.93,332.094v-.945a10.1,10.1,0,0,1-6.529-2.7l-.666.665A10.972,10.972,0,0,0,806.93,332.094Z",
    transform: "translate(-796.252 -307.094)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M821.4,317.688a11.033,11.033,0,0,0-2.991-7.259l-.674.673a10.016,10.016,0,0,1,2.712,6.586Z",
    transform: "translate(-799.317 -304.026)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M809.231,331.153v.944a11,11,0,0,0,7.211-2.959l-.674-.673A10.02,10.02,0,0,1,809.231,331.153Z",
    transform: "translate(-797.869 -307.097)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M820.44,319.992a10.083,10.083,0,0,1-2.736,6.554l.666.665a11,11,0,0,0,3.023-7.219Z",
    transform: "translate(-799.312 -305.655)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M815.923,311.8l-6.117,6.125h8.646A9.387,9.387,0,0,0,815.923,311.8Z",
    transform: "translate(-797.967 -304.259)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M818.452,319.992h-8.646l6.093,6.093A9.414,9.414,0,0,0,818.452,319.992Z",
    transform: "translate(-797.967 -305.655)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M815.315,326.67l-6.084-6.093v8.582A9.458,9.458,0,0,0,815.315,326.67Z",
    transform: "translate(-797.869 -305.754)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M807.162,320.577l-6.068,6.069a9.458,9.458,0,0,0,6.068,2.512Z",
    transform: "translate(-796.483 -305.754)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M799.99,326.061l6.069-6.069h-8.6A9.446,9.446,0,0,0,799.99,326.061Z",
    transform: "translate(-795.865 -305.655)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M797.46,317.926h8.6l-6.093-6.1A9.341,9.341,0,0,0,797.46,317.926Z",
    transform: "translate(-795.865 -304.264)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M801.054,310.716l6.1,6.1v-8.655A9.389,9.389,0,0,0,801.054,310.716Z",
    transform: "translate(-796.476 -303.64)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M810.327,313.568l6.241-6.028a12.257,12.257,0,0,0-6.083-2.912Z",
    transform: "translate(-798.055 -303.038)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M817.066,306.763l.635-.613a12.263,12.263,0,0,0-7.155-3.438l-.015.937A12.528,12.528,0,0,1,817.066,306.763Z",
    transform: "translate(-798.091 -302.712)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliced);
export default __webpack_public_path__ + "static/media/sliced.31186c37304f52a9c7bd1dfc3987700a.svg";
export { ForwardRef as ReactComponent };